import { DragonTigerCardPosition, DragonTigerOutcome, DragonTigerSidePosition } from './dragon-tiger.model';
import { GameType } from '../../../models/communication/app-enums.model';
import { CardPosition, HandValueKey, Outcome } from '../../../models/communication/games.model';
import { GameBase } from '../../game-base';
import { ClassicGameFlow } from '../../game-flows/classic.game.flow';
import { GameConfig } from '../../models/game-config.model';
import { SideState } from '../../models/game-view.model';

export const dragonTigerConfig: GameConfig = {
    sides: [
        {
            position: DragonTigerSidePosition.Tiger,
            hands: [
                {
                    label: $localize`TIGER`,
                    handValueKey: 'tigerHandValue' as HandValueKey,
                    cards: [{ position: DragonTigerCardPosition.TigerCard }]
                }
            ]
        },
        {
            position: DragonTigerSidePosition.Dragon,
            hands: [
                {
                    label: $localize`DRAGON`,
                    handValueKey: 'dragonHandValue' as HandValueKey,
                    cards: [{ position: DragonTigerCardPosition.DragonCard }]
                }
            ]
        }
    ]
};

export class DragonTigerGame extends GameBase {
    static override config = dragonTigerConfig;
    static override gameType = GameType.DragonTiger;
    override flow: ClassicGameFlow = new ClassicGameFlow(this);

    override getFieldLabel(cardPosition: CardPosition): string {
        switch (cardPosition as DragonTigerCardPosition) {
            case DragonTigerCardPosition.DragonCard: {
                return $localize`DRAGON FIELD`;
            }
            case DragonTigerCardPosition.TigerCard: {
                return $localize`TIGER FIELD`;
            }
            default:
                // eslint-disable-next-line no-console
                console.warn(`Unknown card position: ${String(cardPosition)}`);
                return '';
        }
    }

    override getOutcomeLabel(outcome: Outcome): string {
        switch (outcome as DragonTigerOutcome) {
            case DragonTigerOutcome.DragonWin: {
                return $localize`DRAGON WIN`;
            }
            case DragonTigerOutcome.TigerWin: {
                return $localize`TIGER WIN`;
            }
            case DragonTigerOutcome.Tie: {
                return $localize`TIE`;
            }
            default:
                // eslint-disable-next-line no-console
                console.warn(`Unknown outcome: ${String(outcome)}`);
                return '';
        }
    }

    override setOutcomeStates(outcome: Outcome): void {
        switch (outcome as DragonTigerOutcome) {
            case DragonTigerOutcome.Tie:
                this.updateSides(SideState.Tie);
                break;
            case DragonTigerOutcome.TigerWin:
                this.updateSide(DragonTigerSidePosition.Tiger, SideState.Win);
                break;
            case DragonTigerOutcome.DragonWin:
                this.updateSide(DragonTigerSidePosition.Dragon, SideState.Win);
        }
    }
}
